<div class="input-wrapper">
  <mat-checkbox [checked]="textIsEditable" (change)="textIsEditable = !textIsEditable"> Text editable </mat-checkbox>

  <form [formGroup]="formGroup">
    <mad-reactive-form-quick-list-compact
      addLabel="Add"
      [formArray]="array"
      [addPossible]="array.valid"
      [removePossible]="true"
      [readonly]="!textIsEditable"
      [maxItems]="5"
      [minItems]="1"
      (added)="onItemAdded()"
      (removed)="onItemRemoved()"
    >
      <label>Enter some names</label>
      <ng-template let-item>
        <!-- Custom content below -->
        <form [formGroup]="item">
          <span class="fx fx-row">
            <mad-readonly-form-field-wrapper [value]="item.get('id').getRawValue()" [readonly]="!textIsEditable">
              <mat-form-field class="form-group">
                <mat-label>Id</mat-label>
                <input formControlName="id" matInput />
              </mat-form-field>
            </mad-readonly-form-field-wrapper>

            <mad-readonly-form-field-wrapper [value]="item.get('name').getRawValue()" [readonly]="!textIsEditable">
              <mat-form-field class="form-group">
                <mat-label>Name</mat-label>
                <input formControlName="name" matInput required />
                <mat-error> Please enter a last name </mat-error>
              </mat-form-field>
            </mad-readonly-form-field-wrapper>
          </span>
        </form>
      </ng-template>
    </mad-reactive-form-quick-list-compact>
  </form>
</div>
